import _ from 'lodash';

const frAccents = ['aáäàãâ', 'cç', 'eéèêë', 'iíïìî', 'oóöòô', 'uúüùû'];

export default function createAccentInsensitiveRegex(text) {
  return _.chain(text)
    .escapeRegExp()
    .split('')
    .map(char => {
      const lowerChar = char.toLocaleLowerCase();
      const accents = _.find(frAccents, a => a.includes(lowerChar));
      return accents ? `[${accents}]` : char;
    })
    .value()
    .join('');
}
